// extracted by mini-css-extract-plugin
module.exports = {"avatar":"AvatarHolder_avatar__ju9D6","avatarCanvas":"AvatarHolder_avatarCanvas__3cwpL"};